import { useMemo } from 'react';

import type { Feature } from 'geojson';

import { useAppSelector } from '@/hooks/useAppSelector';

import { generateFloodGridData, type FloodCell } from '../utils/demoDataGenerator';

/**
 * Lưới ô phân tích ngập demo — cùng tham số trên 2D và 3D (zoom làm tròn từ Redux để giảm tính lại khi pan).
 *
 * @param regionFeatures — `floodGeoJson.features` từ hook `useHanoiFloodDemoGeoJson` (một nguồn fetch).
 */
export function useFloodAnalysisGridData(
  regionFeatures: readonly Feature[] | null | undefined,
): FloodCell[] {
  const geeYear = useAppSelector((s) => s.map.geeParams.year);
  const selectedDate = useAppSelector((s) => s.scenario.selectedDate);
  const selectedRegionId = useAppSelector((s) => s.map.selectedRegionId);
  /** Làm tròn zoom để giảm số lần sinh lại lưới khi pan (logic vùng chỉ phụ thuộc ngưỡng zoom nguyên). */
  const mapZoomBucket = useAppSelector((s) => Math.round(s.map.mapView.zoom));

  return useMemo(
    () =>
      generateFloodGridData(
        geeYear,
        selectedDate,
        regionFeatures ?? null,
        mapZoomBucket,
        selectedRegionId,
      ),
    [geeYear, selectedDate, regionFeatures, mapZoomBucket, selectedRegionId],
  );
}
